export default {
    intro: `อ่านเนื้อเรื่องให้ดี แล้วมาตอบคำถามของเจ้าเหมียวควิซกันเถอะ<br/>
            พอทำเสร็จหมด ของว่างอร่อยๆ รออยู่นะ!`,
    correct: 'ถูกต้อง',
    incorrect: 'ผิด',
    next: 'ถัดไป',
    greetings: [
        'เมี้ยว! ข้าคือเจ้าเหมียวควิซเมี้ยว วันนี้มาอ่านเนื้อเรื่องแล้วคุยกันเมี้ยว',
        'เมี้ยว! ข้าคือเจ้าเหมียวควิซเมี้ยว มาอ่านข้อความแล้วหาเนื้อหาสำคัญกันเมี้ยว',
        'เมี้ยว! ข้าคือเจ้าเหมียวควิซเมี้ยว อ่านเนื้อเรื่องแล้วมาตอบควิซให้ถูกเมี้ยว',
        'เมี้ยว! ข้าชื่อเจ้าเหมียวควิซเมี้ยว มาตอบควิซที่ข้าออกให้ถูกเมี้ยว',
        'เมี้ยว! เจ้าเหมียวควิซมาแล้วเมี้ยว ไปตอบควิซด้วยกันกับข้าเมี้ยว',
    ],
    reactions: [
        'เข้าใจแล้ว! จะลองทำข้อต่อไปด้วย',
        'พอฟังคำอธิบายก็เข้าใจชัดเจนเลย',
        'อยากลองทำข้อต่อไปอีก!',
        'เพราะคำอธิบายเลยเริ่มจับทางได้ จะทำต่อไปนะ',
        'ไม่ยากอย่างที่คิดเลย',
    ],
    finalReactions: [
        'ในที่สุดก็ตอบถูกหมดแล้ว! ตอนนี้กินอะไรได้หรือยัง?',
        'ทำโจทย์เสร็จหมดแล้ว! ตื่นเต้นที่จะได้เลือกอาหาร',
        'อยากรีบเลือกว่าจะกินอะไรดี',
        'พอตั้งใจทำก็หิวเลย กินอะไรดีนะ?',
        'ตื่นเต้นจัง (พลางจินตนาการว่าจะกินอะไร)',
    ],
    snackReactions: ['ทำเสร็จหมดเลยเก่งนี่เมี้ยว เลือกของว่างที่อยากกินมาสักอย่างสิเมี้ยว'],
};
